var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGonogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gonogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5, 0.5)",
    fill: "none",
    stroke: "currentColor",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,29V19.5A2.476,2.476,0,0,1,35.5,17h0A2.476,2.476,0,0,1,38,19.5V29",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,29V18.5A2.476,2.476,0,0,1,30.5,16h0A2.476,2.476,0,0,1,33,18.5V20",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.598 4 20.402 4 4 20.402 4 43.598 20.402 60 43.598 60 60 43.598 60 20.402 43.598 4",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,22V20.643a2.6,2.6,0,0,0-2.242-2.63A2.5,2.5,0,0,0,23,20.5V34l-2.508-3.669a2.994,2.994,0,0,0-5.3.618,2.936,2.936,0,0,0,.225,2.553L21.612,44.04A6,6,0,0,0,26.784,47H37a6,6,0,0,0,6-6V24.643a2.6,2.6,0,0,0-2.242-2.63A2.5,2.5,0,0,0,38,24.5V30",
    strokeLinecap: "round",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGonogo);
export default __webpack_public_path__ + "static/media/gonogo.30b58cc8a6462abe2356f59df074fea3.svg";
export { ForwardRef as ReactComponent };